import { render, staticRenderFns } from "./FixedOddBingoPlayerScreen.vue?vue&type=template&id=59ee5917&scoped=true&"
import script from "./FixedOddBingoPlayerScreen.vue?vue&type=script&lang=js&"
export * from "./FixedOddBingoPlayerScreen.vue?vue&type=script&lang=js&"
import style0 from "./FixedOddBingoPlayerScreen.vue?vue&type=style&index=0&id=59ee5917&scoped=true&lang=css&"
import style1 from "./FixedOddBingoPlayerScreen.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ee5917",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDialog,VRow})
